import { defineStore } from 'pinia'
import type { EnhancingItem } from '@/types/enhancingItem'
interface EnhancementsState {
  enhancingItems: EnhancingItem[]
  selectedItem: number | null
}

export const useEnhancementsStore = defineStore('enhancements', {
  state: (): EnhancementsState => ({
    enhancingItems: [],
    selectedItem: null
  }),
  actions: {
    setEnhancingItems(items: EnhancingItem[]): void {
      this.enhancingItems = items
    },
    updateEnhancingItem(item: EnhancingItem): void {
      const index = this.enhancingItems.findIndex((enhancingItem:EnhancingItem) => enhancingItem.name == item.name)
      if (index >= 0) {
        this.enhancingItems[index] = item
      }
    },
    resetEnhancementState(): void {
      this.enhancingItems = []
    },
    updateSelectedItem(index:number | null){
      this.selectedItem = index;
    }
  },
})
